import {createSlice } from '@reduxjs/toolkit'

const MonthSliceAR = createSlice({
    name: "MonthSliceAR",
    initialState: {
        SelectedMonthAR: {
            id: 0,
            Name: '',
            MonthValue: 0,
            YearVelue: 0,
        },
        MonthArrayAR: [],
    },
    reducers: {
       MonthArrayAddAR(state, actions){
            state.MonthArrayAR = actions.payload
       },
       SelectMonthAR(state, actions){
        state.SelectedMonthAR = {
            id: 0,
            Name: '',
            MonthValue: 0,
            YearVelue: 0
        }
            state.SelectedMonthAR = actions.payload
       },
       ClearSelectedMonthAR(state){
        state.SelectedMonthAR = {
            id: 0,
            Name: '',
            MonthValue: 0,
            YearVelue: 0
        }
       }
    }
})

export default MonthSliceAR.reducer
export const { MonthArrayAddAR, SelectMonthAR, ClearSelectedMonthAR } = MonthSliceAR.actions